<template>
  <div class="style">
    <ul class="form">
      <li v-for="(item, index) in form.itemList" :key="index" style="background-color:#fff">
         <!-- 1单行文本 -->
        <mt-field :label="item.title" :placeholder="item.description" type="text" v-model="item.defaultValue" v-if="item.type === 1">
          <i slot="icon">*</i>
        </mt-field>
        <!-- 2多行文本 -->
        <mt-field :label="item.title" :placeholder="item.description" type="textarea" rows="3" v-model="item.defaultValue" v-if="item.type === 2"></mt-field>
          <!-- 3数字 -->
        <mt-field :label="item.title" :placeholder="item.description" type="number" v-model="item.defaultValue" v-if="item.type === 3"></mt-field>
        <!-- 4日期 -->
        <mt-field :label="item.title" :placeholder="item.description" type="date" v-model="item.defaultValue" v-if="item.type === 4"></mt-field>
        <!-- 5单选 -->
        <div class="dborder" v-if="item.type === 5">
          <van-radio-group v-model="item.defaultValue">
            <p class="pborder">{{item.title}}</p>
            <van-radio v-for="(items, index) in item.options" :key="index" :name="items">{{items}}</van-radio>
          </van-radio-group>
        </div>
        <!-- <mt-radio :title="item.title" v-model="item.defaultValue" :options="item.options" v-if="item.type === 5"> </mt-radio> -->
        <!-- 6多选 -->
        <mt-checklist :title="item.title" v-model="item.defaultValue" :options="item.options" v-if="item.type === 6"></mt-checklist>
         <!-- 7图片 -->
         <!-- <ul>
           <li v-for="(img_url, index) in images[item.itemId]" :key="index" class="imgs" style="margin-bottom: 16px;">
               <div style="background-color:#fff;display:flex;justify-content: center;">
                <img class="addimgs" :src="img_url">
                <van-icon size='20px' name="close" @click="delImg(index,item.itemId)" class="delte"/>
              </div>
           </li>
         </ul> -->
         <div v-for="(img_url, index) in images[item.itemId]" :key="index" class="imgs" style="margin-bottom: 16px;">
           <div style="background-color:#fff;display:flex;justify-content: center;">
              <img class="addimgs" :src="img_url">
              <van-icon size='20px' name="close" @click="delImg(index,item.itemId)" class="delte"/>
            </div>
          </div>
         <div class="uploaderImg" v-if="item.type === 7">
          <van-uploader multiple :after-read="onRead" :disabled="images[currentImageItemId] && images[currentImageItemId].length >= item.defaultValue" :max-size="10485760" @click.native="changeImageItemId(item.itemId)">
            <!-- <div class="imgs">
              <van-icon name="close" @click="delImg(index,item.itemId)" class="delte"/>
              <img v-for="(img_url, index) in images[item.itemId]" :key="index" :src="img_url">
          </div> -->
            <van-icon name="upgrade"></van-icon> 上传{{item.title}} (限数：{{ item.defaultValue }})
          </van-uploader>
        </div>
        <!-- 8说明文字 -->
        <p v-if="item.type === 8" class="text">
          <span class="left">{{ item.title }}</span>
          <span class="right">{{ item.defaultValue }}</span>
        </p>
      </li>
      <!-- <li style="background-color:#fff;padding:0 12px">
        <p style="padding:10px 0px;border-bottom:1px solid #e6e0e0">是否需要发票</p>
        <div>
          <van-radio-group v-model="radio">
            <van-radio name="1" clickable @click="radio = '1'" style="padding: 8px 0;">是</van-radio>
            <van-radio name="2" clickable @click="radio = '2'" style="padding: 8px 0;">否</van-radio>
          </van-radio-group>
        </div>
      </li> -->
    </ul>
    <!-- <van-list v-model="loading" v-if="parseInt(radio) == 1" :finished="finished" @load="loadMore" style="padding-top: 12px;">
      <van-panel title="发票信息" :class="activeClass == index ? 'carun cpindd':'cpindd'" @click="getItme(index)" v-for="(item, index) in invoice_list" :key='index' @click="chack(index)">
        <van-row class="invoice-item">
          <van-col class="left" span="8">发票类型：</van-col>
          <van-col class="right" span="14" offset="2">{{item.invoiceType===2?'增值税发票':'普通发票'}}</van-col>
        </van-row>
        <van-row class="invoice-item">
          <van-col class="left" span="8">发票抬头：</van-col>
          <van-col class="right" span="14" offset="2">{{item.invoiceTitle}}</van-col>
        </van-row>
        <van-row class="invoice-item" v-show="item.invoiceType===2 || item.type===1">
          <van-col class="left" span="8">纳税人识别号：</van-col>
          <van-col class="right" span="14" offset="2">{{item.creditCode}}</van-col>
        </van-row>
        <van-row class="invoice-item" v-show="item.invoiceType===2">
          <van-col class="left" span="8">注册地址：</van-col>
          <van-col class="right" span="14" offset="2">{{item.registerAddress}}</van-col>
        </van-row>
        <van-row class="invoice-item" v-show="item.invoiceType===2">
          <van-col class="left" span="8">注册电话：</van-col>
          <van-col class="right" span="14" offset="2">{{item.registerTel}}</van-col>
        </van-row>
        <van-row class="invoice-item" v-show="item.invoiceType===2">
          <van-col class="left" span="8">开户银行：</van-col>
          <van-col class="right" span="14" offset="2">{{item.bankName}}</van-col>
        </van-row>
        <van-row class="invoice-item" v-show="item.invoiceType===2">
          <van-col class="left" span="8">银行账号：</van-col>
          <van-col class="right" span="14" offset="2">{{item.bankAccount}}</van-col>
        </van-row>
        <van-row class="invoice-item">
          <van-col class="left" span="8">收票人手机：</van-col>
          <van-col class="right" span="14" offset="2">{{item.receiverMobile ===''?'--':item.receiverMobile}}</van-col>
        </van-row>
      </van-panel>
    </van-list> -->
    <div class="footer">
      <mt-button class="myButton" @click.native="beforeSubmit" size="small">{{ form.buttonName ? form.buttonName : '提交' }}</mt-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Field, Toast } from 'mint-ui';
import { Uploader, RadioGroup, Radio } from 'vant';
import deepcopy from '@/utils/deepcopy';

export default {
  data() {
    return {
      form: {},
      radio: "1",
      invoiceId:'',
      activeClass:-1,
      // username: '',
      // minDate: new Date(),
      loading: false,
      finished: false,
      pageIndex: 1,
      invoice_list: [],
      totalPage: 0,
      qiniuConfig: {},
      images: [], // 待上传图片列表。结构：itemId: ['imgUrl', ...], ...
      currentImageItemId: 0, // 可能存在多个上传图片控件
    }
  },
  props: {
    formObj: {
      type: Object,
      default() {
        return {}
      },
    },
    showModal:{
      type: Boolean,
      default: true
    }
  },
  created() {
    this.initForm();
    this.getList();
  },
  mounted(){
    if(this.showModal) this.getUploadToken();
  },
  methods: {
    initForm(){
      this.form = deepcopy(this.formObj);
      this.form.itemList.forEach((val, i) => {
        if(val.type===5){
          // console.log(val.options)
        }
        if(val.title=="联系人") {
          val.defaultValue = this.localuser.realName || this.localuser.userNick;
        }
        if(val.title=="联系电话" || val.title=="联系号码" ||val.title=="联系方式") {
          val.defaultValue = this.localuser.userMobile;
        }
        if(val.title=="公司名称" || val.title=="企业名称") {
          if(this.localuser.bindCorpInfo && this.localuser.bindCorpInfo.corpName){
            val.defaultValue = this.localuser.bindCorpInfo.corpName;
          }
        }
        if(val.title.search("地址") != -1) {
          if((this.$route.query.qrId || this.$route.query.bindQr==1) && this.qrcodeServiceInfo.address){
            val.defaultValue = this.qrcodeServiceInfo.address;
          } else if(this.localuser.bindCorpInfo && this.localuser.bindCorpInfo.corpAddress){
            val.defaultValue = this.localuser.bindCorpInfo.corpAddress;
          } else if(this.localuser.userCardInfo && this.localuser.userCardInfo.address) {
            val.defaultValue = this.localuser.userCardInfo.address;
          }
        }
      })
    },
    getList(){
      this.$http.post(`${this.URL_PREFIX}/app/get/user/invoice/info/list`,{
        currPage: this.pageIndex,
        pageRows: 10,
      },{
        headers: { token: this.token },
      }).then((res) => {
        if(res.data.resCode == 10000){
          this.totalPage = res.data.resData.length>0?res.data.resData.pageInfo.total:0;
          let pageList = res.data.resData.pageList ? res.data.resData.pageList : [];
          this.invoice_list = this.invoice_list.concat(pageList);
          this.finished = this.invoice_list.length >= this.totalPage ? true : false;
        }else{
          Toast(res.data.resDesc);
        }
        this.loading = false;
      })
    },
    loadMore() {
      if (this.invoice_list.length >= this.totalPage) {
        return;
      }
      this.loading = true;
      this.pageIndex++;
      // this.getList();
    },
    chack(index){
      this.invoiceId = this.invoice_list[index].invoiceId;
    },
    getItme(index) {
        this.activeClass = index;  // 把当前点击元素的index，赋值给activeClass
    },
    beforeSubmit() {  // 验证数据
      // 正则验证
      // var regFlag = false;

      // for (let i = 0; i < this.form.itemList.length; i++) {
      //   if (this.form.itemList[i].regularExpres) {
      //     if (!new RegExp(this.form.itemList[i].regularExpres).test(this.form.itemList[i].defaultValue)) {
      //       Toast(this.form.itemList[i].description);
      //       regFlag = true;
      //       break;
      //     }
      //   }
      // }
      // if (regFlag) {
      //   return;
      // }
      // 正则验证结束


      const mustIndex = this.form.itemList.findIndex((val) => {
        return val.ismust && val.defaultValue.length === 0;
      });
      const picIndex = this.form.itemList.findIndex((val) => {
        return val.ismust && val.type === 7 && this.images.length === 0;
      });
      if (mustIndex !== -1) {
        Toast(`请填写${this.form.itemList[mustIndex].title}内容`);
      } else if (picIndex !== -1) {
        Toast('请上传图片');
      } else {
        this.submit();
      }
    },
    submit() {  // 提交表单
      const Form = deepcopy(this.form);
      const content = [];
       Form.itemList.forEach((val) => {
        if (val.type === 6) {  // 处理多选
          val.defaultValue = val.defaultValue ? val.defaultValue.toString() : '';
        } else if (val.type === 3) {  // 处理数字
          val.defaultValue = val.defaultValue + '';
        } else if (val.type === 7) {  // 处理图片
          if (this.images[val.itemId] != undefined && this.images[val.itemId].length) {
            val.defaultValue = this.images[val.itemId].toString();
          } else {
            val.defaultValue = '';
          }
        }

        content.push({
          itemId: val.itemId,
          title: val.title,
          type: val.type,
          value: val.defaultValue,
        });
      });
      content.push({
          itemId: 9999,
          title: "发票",
          type: 999,
          value:this.invoiceId
      });
      this.$emit('finishForm', content);
    },
    getUploadToken() {  // 获取七牛token
      const needPic = this.formObj.itemList.findIndex((val) => {
        return val.type == 7;
      });
      if (needPic !== -1) {
        this.$http.post(`${this.URL_PREFIX}/app/get/qiniu/bucket/token`, {}, {
          headers: { token: this.token },
        }).then((response) => {
          const res = response.data;
          if (res.resCode === '10000') {
            this.qiniuConfig = res.resData;
          }
        });
      }
    },
    // beforeUploader(num) {  // 上传前
    //   if (Number(num) < this.images.length) {
    //     Toast({
    //       message: '操作成功',
    //       iconClass: 'icon icon-success'
    //     });
    //     return;
    //   }
    // },
    changeImageItemId(itemId){
      this.currentImageItemId = itemId
    },
    onRead(uploader) {   // 图像上传
      let param = new FormData();
      param.append('file', uploader.file);
      param.append('token', this.qiniuConfig.token);
      let config = {
        headers:{ 'Content-Type': 'multipart/form-data' }
      };
      this.$http.post('http://up-z2.qiniup.com/', param, config).then((response) => {
        const res = response.data;
        if(this.images[this.currentImageItemId] == undefined) this.$set(this.images, this.currentImageItemId, [])
        this.images[this.currentImageItemId].push(`${this.qiniuConfig.domain}/${res.key}`);
      });
      
    },
    delImg (index,itemId) {
      // 删除指定下标的图片对象
      console.log(index,itemId)
      this.currentImageItemId = itemId
      if (isNaN(index) || index >= this.images.length) {
        return false
      }
      this.images[itemId].splice(index,1);
      // let tmp = []
      // for (let i = 0, len = this.images.length; i < len; i++) {
      //   if (this.images[itemId][i] !== this.images[itemId][index]) {
      //     tmp.push(this.images[itemId][i])
      //   }
      // }
      // this.images = tmp
      console.log(this.images);
    },

  },
  computed: {
    ...mapGetters(['token', 'localuser', 'qrcodeServiceInfo']),
  },
  watch: {
    formObj() {
      this.initForm();
      this.getUploadToken();
    },
    showModal(v){
      if(v) this.getUploadToken();
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@scss';
h3 {
  text-align: center;
  margin-bottom: 10px;
  font-weight: 600;
}
.van-list{
  .cpindd{
    .van-panel__content{
      padding: 10px;
    }
  }
}
.van-list{
  .carun{
    .van-panel__content{
      background: #e5ece8;
    }
  }
}
.dborder{
  border-top: 1px solid #e6e0e0;
  padding-bottom: 10px;
  padding-left:10px;
  .van-radio{
    padding-bottom: 5px;
  }
}
.pborder{
    border-bottom: 1px solid #e6e0e0;
    padding: 16px 10px;
    margin-bottom: 10px;
}
.addimgs{
  width: 90%;
  height: 100%;
}
.mint-cell-wrapper {
  border-bottom: 1px solid #c4c4c4;
}
.form {
  background-color: rgb(245, 245, 245);
  .mint-field,
  .mint-cell,
  .mint-checklist,
  .mint-radiolist
  {
    padding: 2px 0;
    margin-bottom: .026667rem;
    font-size: .4rem;
    color: rgb(67, 67, 67);
    .mint-checklist-title {
      padding: 8px;
      margin: 0;
      background-color: #fff;
    }
    .mint-radiolist-title {
      background-color: #fff;
    }
  }
  .uploaderImg {
    padding: 10px;
    margin-bottom: .026667rem;
    min-height: 2.666667rem;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .van-icon{
      vertical-align: bottom;
    }
    .imgs {
      background: #fff;
      display: flex;
      justify-content: center;
      img {
        margin-right: px2rem(20);
        max-height: px2rem(300);
        margin-bottom: .366667rem;
      }
    }
  }
  .text{
    padding: 0 10px;
    background-color: #fff;
    display: flex;
    .left{
      flex: 0 0 2.8rem;
      width: 2.8rem
    }
    .right {
      flex: 1 1 auto;
    }
  }
}
.footer{
  padding: px2rem(10) px2rem(32);
  background-color: #fff;
  margin-top: .4rem;
  box-sizing: border-box;
  width: 100%;
  .mint-button{
    width: 100%;
    background: #d9262c;
    color: #fff;
    height: px2rem(78);
    font-size: px2rem(37);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CustomForm.vue